import type { NotificationRecord } from "@shared/types";
import type { TokenRequest } from "ably";
import { apiClient } from "@/lib/api-client";

const API_BASE = "/api/v1/notifications";

export type Notification = NotificationRecord;

export interface NotificationsQuery {
	limit?: number;
	after?: string;
	before?: string;
}

export interface RealtimeAuthTokenResponse {
	tokenRequest: TokenRequest;
	channel: string;
	clientId: string;
}

export async function getNotifications(
	query: NotificationsQuery = {},
): Promise<Notification[]> {
	try {
		const response = await apiClient.get(API_BASE, { params: query });
		return response.data.data.notifications;
	} catch {
		return [];
	}
}

export async function markNotificationRead(
	id: string,
): Promise<{ success: boolean; error?: string }> {
	try {
		await apiClient.patch(`${API_BASE}/${id}/read`);
		return { success: true };
	} catch (error: unknown) {
		const err = error as { response?: { data?: { message?: string } } };
		return {
			success: false,
			error: err.response?.data?.message || "Failed to mark notification read",
		};
	}
}

export async function markAllNotificationsRead(): Promise<{
	success: boolean;
	error?: string;
}> {
	try {
		await apiClient.post(`${API_BASE}/read-all`);
		return { success: true };
	} catch (error: unknown) {
		const err = error as { response?: { data?: { message?: string } } };
		return {
			success: false,
			error: err.response?.data?.message || "Failed to mark all read",
		};
	}
}

export async function createRealtimeAuthToken(): Promise<RealtimeAuthTokenResponse> {
	const response = await apiClient.post(`${API_BASE}/realtime/auth`);
	return response.data.data;
}
